import React, { useState } from 'react';
import TopSection from "../../Components/Common/Top/TopSection";
import { Box, Grid, Stack } from "@mui/material";
import ForecastPerformance from './ForecastPerformance/ForecastPerformance';
import ForecastTracker from './ForecastTracker/ForecastTracker';
import ErrorPerformance from './ErrorPerformance/ErrorPerformance';
import { styled } from '@mui/material/styles';

const chartTabs = [
  { label: "Forecast Tracker" },
  { label: "Performance History" },
  { label: "Error Performance" },
];

// Styled pill container and pill label (reuse style from ForecastTracker)
const PillContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  borderRadius: 20,
  background: '#f5f5f5',
  height: 32, // reduced height
  minWidth: 550, // slightly reduced width
  alignItems: 'center',
  boxShadow: '0 0 0 1px #ddd',
}));

const PillHighlight = styled('div')(({ selected }) => ({
  position: 'absolute',
  top: 2,
  left: selected * (100 / chartTabs.length) + '%',
  width: `calc(${100 / chartTabs.length}% - 4px)`,
  height: 'calc(100% - 4px)',
  background: '#222',
  borderRadius: 16,
  transition: 'left 0.25s cubic-bezier(.4,0,.2,1)',
  zIndex: 1,
}));

const PillLabel = styled('div')(({ active }) => ({
  position: 'relative',
  zIndex: 2,
  flex: 1,
  textAlign: 'center',
  fontSize: '0.95rem',
  fontWeight: active ? 600 : 400,
  color: active ? '#fff' : '#222',
  cursor: 'pointer',
  minWidth: 140, // same width for all pills
  padding: '0 12px',
  userSelect: 'none',
  transition: 'color 0.2s',
  lineHeight: '28px',
}));

const Metrics = () => {
  const [selectedChartTab, setSelectedChartTab] = useState(0);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div style={{ minHeight: "600px", marginTop: "10px" }}>
              {/* Chart tabs as pill filter */}
              <Box sx={{ m: 1, display: "flex", gap: 2 }}>
                <PillContainer>
                  <PillHighlight selected={selectedChartTab} />
                  {chartTabs.map((tab, idx) => (
                    <PillLabel
                      key={tab.label}
                      active={selectedChartTab === idx}
                      onClick={() => setSelectedChartTab(idx)}
                      style={{
                        fontWeight: selectedChartTab === idx ? 600 : 400
                      }}
                    >
                      {tab.label}
                    </PillLabel>
                  ))}
                </PillContainer>
              </Box>

              {/* Main content area: Show only the selected graph */}
              <Box sx={{ flex: 1, p: 1 }}>
                {selectedChartTab === 0 && <ForecastTracker />}
                {selectedChartTab === 1 && <ForecastPerformance />}
                {selectedChartTab === 2 && <ErrorPerformance />}
              </Box>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default Metrics;